
import { format } from "date-fns"
import { CalendarIcon, Clock } from "lucide-react"
import { Button } from "@/components/ui/button"
import { Input } from "@/components/ui/input"
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover"
import { Calendar } from "@/components/ui/calendar"
import { useNapForm, NapFormData } from "../NapFormContext"
import { DateTimeInput } from "@/components/ui/date-time-input"

// Consistent interface for all step components
interface TimeStepProps {
  type: "start" | "end"
  childName?: string
  onNext: () => void
  onPrev?: () => void
}

export function TimeStep({ type, childName, onNext, onPrev }: TimeStepProps) {
  // Get form context instead of receiving as prop
  const form = useNapForm();
  
  const timeValue = form.watch(`${type}_time`)
  const timeInputValue = form.watch(`${type}_time_input`)
  
  const isStartStep = type === 'start';
  const label = isStartStep ? 'fall asleep' : 'wake up';

  return (
    <div className="space-y-6">
      <h3 className="text-lg font-medium text-center">
        When did {childName || 'your baby'} {label}?
      </h3>
      <div className="max-w-xs mx-auto">
        <DateTimeInput
          date={timeValue}
          time={timeInputValue}
          onDateChange={(date) => {
            // Preserve the timezone information from the user's browser
            form.setValue(`${type}_time`, date)
            console.log(`Setting ${type} time with preserved timezone:`, date.toString())
          }}
          onTimeChange={(time) => {
            form.setValue(`${type}_time_input`, time)
            console.log(`Setting ${type} time input:`, time)
          }}
        />
      </div>
      
      <div className="flex justify-between pt-4">
        {!isStartStep && onPrev && (
          <Button 
            type="button" 
            variant="outline" 
            onClick={onPrev}
            className="border-white/10 text-gray-300 hover:bg-white/5"
          >
            Back
          </Button>
        )}
        
        <Button
          type="button"
          onClick={onNext}
          className={`${isStartStep ? 'ml-auto' : ''} bg-purple-500 hover:bg-purple-600 text-white`}
        >
          Continue
        </Button>
      </div>
    </div>
  )
}
